<template>
  <section class="head-image w-100 bg-cl-th-accent cl-white ">
    <div class="head-image-bg w-100 h-100 cl-black">
      <img :src="s3Path(background)" alt="head image background" width="100%" height="100%" loading="eager" fetchpriority="high" />
      <div class="head-image-content w-100 flex center-xs pt10 pb10">
        <h1 class=" middle-xs underline cl-white category-title">
          <span v-if="isCategoryPage">
            Замовити {{ getActivePartnersCategory.title }} в
            <router-link class="locationLink" :to="localizedRoute('/' + locationInfo.code)">{{ locativeLocationName }}</router-link>
            онлайн
          </span>
          <span class="bold" v-else-if="isTagPage">
            Замовити {{ selectTags[0].title }} в
            <router-link class="locationLink" :to="localizedRoute('/' + locationInfo.code)">{{ locativeLocationName }}</router-link>
            онлайн
          </span>
        </h1>
        <div v-if="ifChangeTitle">
           <p class="fs16 cl-white m0" >{{ selectTags[0].about }}</p>
        </div>
        <div v-else>
          <p class="fs16 cl-white m0 text-onclick-tag" > {{ $t('Here you can get acquainted with our partners') }} </p>
        </div>
        <about-popup name="modal-about" :width="300" />
        <search-partner/>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import config from 'config';
  import {s3Path, headBackgroundPath} from "@vue-storefront/core/helpers";
  import { declineCityLocative } from 'theme/helpers/declineCityLocative'
  const SearchPartner = () => import(/* webpackChunkName: "vsf-component-search-partner" */ './SearchPartner');
  const AboutPopup = () => import(/* webpackChunkName: "vsf-component-about-popup" */ 'theme/components/core/AboutPopup');

  export default {
    components: {
      AboutPopup,
      SearchPartner
    },
    data () {
      return {
        store: {
          title: 'Доставка звідусіль',
          subtitle: 'Ми одна з найбільших мереж доставки товарів до ваших дверей'
        },
        loadModal: false,
      }
    },
    computed: {
      ...mapGetters({
        currentImage: 'promoted/getHeadImage',
        tags: 'partner_tags/getTags',
        selectTags: 'partner_tags/getSelectedTags',
        getActivePartnersCategory: 'partner_categories/getActivePartnersCategory',
        locationInfo : 'locations/getActiveLocation',
        metaInformation: 'configs/getMetaInformation',
        seoStats: 'partners/getCategorySeoStats',
        device: 'ui/getDevice'
      }),
      background () {
        return headBackgroundPath(this.device)
      },
      // Locative case for "в {city}" phrasing in the H1/title/description.
      locativeLocationName () {
        return declineCityLocative(this.locationInfo.name)
      },
      ifChangeTitle () {
        return this.selectTags && this.selectTags.length
      },
      isCategoryPage () {
        return !this.ifChangeTitle && !!this.$route.params.listId &&
          this.getActivePartnersCategory && this.getActivePartnersCategory.hasOwnProperty('title')
      },
      // Only true once stats have actually loaded and confirmed zero
      // partners - never while stats are simply unloaded/unreachable, so a
      // stats-endpoint hiccup can't wrongly noindex a page that has real
      // content. Ticket requirement: index,follow only on pages "with real
      // content".
      isThinPage () {
        return this.seoStats.loaded && !this.seoStats.count
      },
      robotsContent () {
        return this.isThinPage ? 'noindex, follow' : 'index, follow'
      },
      // Templated per K2-2985: title/description are generated live from
      // category+location data (partner_count, avg_delivery_time) instead of
      // relying on hand-written per-page copy - see CategorySeoContent.vue.
      templatedTitle () {
        if (!this.isCategoryPage) {
          return null
        }
        const category = this.getActivePartnersCategory.title
        const city = this.locativeLocationName
        const time = this.seoStats.avg_delivery_time
        const count = this.seoStats.count
        return `Замовити ${category} в ${city}` +
          (time ? ` з доставкою до ${time} хв` : '') +
          (count ? ` — ${count}+ закладів` : '') +
          ' | Korzyna'
      },
      templatedDescription () {
        if (!this.isCategoryPage) {
          return null
        }
        const category = this.getActivePartnersCategory.title
        const city = this.locativeLocationName
        const time = this.seoStats.avg_delivery_time
        const count = this.seoStats.count
        return `Замовляйте ${category} з доставкою в ${city}.` +
          (count ? ` ${count}+ перевірених закладів.` : '') +
          (time ? ` Доставка за ${time} хв.` : '') +
          ` Обирайте та замовляйте онлайн на Korzyna.`
      },
      canonicalPath () {
        if (this.isCategoryPage) {
          return `${this.getHostPath}/${this.locationInfo.code}/${this.getActivePartnersCategory.code}`
        }
        return this.getHostPath + this.localizedRoute(this.$route.fullPath)
      },
      // The tag is the real ranking target for local-intent queries like
      // "замовити суші тернопіль" (партнер cuisine tags, not the coarser
      // "food"/"shop" partner category) - see CategorySeoContent.vue.
      isTagPage () {
        return this.ifChangeTitle && this.selectTags[0] && this.selectTags[0].hasOwnProperty('title')
      },
      templatedTagTitle () {
        if (!this.isTagPage) {
          return null
        }
        const tag = this.selectTags[0].title
        const city = this.locativeLocationName
        const time = this.seoStats.avg_delivery_time
        const count = this.seoStats.count
        return `Замовити ${tag} в ${city}` +
          (time ? ` з доставкою до ${time} хв` : '') +
          (count ? ` — ${count}+ закладів` : '') +
          ' | Korzyna'
      },
      templatedTagDescription () {
        if (!this.isTagPage) {
          return null
        }
        const tag = this.selectTags[0].title
        const city = this.locativeLocationName
        const time = this.seoStats.avg_delivery_time
        const count = this.seoStats.count
        return `Замовляйте ${tag} з доставкою в ${city}.` +
          (count ? ` ${count}+ перевірених закладів.` : '') +
          (time ? ` Доставка за ${time} хв.` : '') +
          ` Обирайте та замовляйте онлайн на Korzyna.`
      },
      tagCanonicalPath () {
        if (this.isTagPage && this.getActivePartnersCategory) {
          return `${this.getHostPath}/${this.locationInfo.code}/${this.getActivePartnersCategory.code}/${this.selectTags[0].code}`
        }
        return this.getHostPath + this.localizedRoute(this.$route.fullPath)
      },
      metaDescription () {
        return this.metaInformation.find(meta => meta.key === 'description').value
      },

      metaKeywords () {
        return this.metaInformation.find(meta => meta.key === 'keywords').value
      },

      ogMetaType () {
        if (this.metaInformation.find(meta => meta.key === 'og_type')) {
          return this.metaInformation.find(meta => meta.key === 'og_type').value
        }
        return ''
      },

      ogMetaTitle () {
        if (this.metaInformation.find(meta => meta.key === 'og_title')) {
          return this.metaInformation.find(meta => meta.key === 'og_title').value
        }
        return ''
      },

      ogMetaDescription () {
        if (this.metaInformation.find(meta => meta.key === 'og_description')) {
          return this.metaInformation.find(meta => meta.key === 'og_description').value
        }
        return ''
      },

      ogMetaImage () {
        if (this.metaInformation.find(meta => meta.key === 'og_image')) {
          return this.metaInformation.find(meta => meta.key === 'og_image').value
        }
        return ''
      },
      getHostPath () {
        return config.canonical ? config.canonical.url : ''
      }
    },
    metaInfo () {
      if (this.ifChangeTitle) {
        let locationMeta = {}
        if (this.selectTags[0].meta) {
          this.selectTags[0].meta.map(meta => {
            if (meta.location_code === this.locationInfo.code) {
              locationMeta = meta
            }
          })
        }
        let currentLocationMeta = [
            {
              vmid: 'description',
              name: 'description',
              content: this.templatedTagDescription || locationMeta.meta_description || this.metaDescription
            },
            {
              vmid: 'robots',
              name: 'robots',
              content: this.robotsContent
            },
            {
              vmid: 'keywords',
              name: 'keywords',
              content: locationMeta.meta_keywords ? locationMeta.meta_keywords : this.metaKeywords
            },
            {
              vmid: 'og:type',
              property: 'og:type',
              content: locationMeta.og_meta_type ? locationMeta.og_meta_type : this.ogMetaType
            },
            {
              vmid: 'og:title',
              property: 'og:title',
              content: locationMeta.og_meta_title ? locationMeta.og_meta_title : (this.templatedTagTitle || this.ogMetaTitle)
            },
            {
              vmid: 'og:description',
              property: 'og:description',
              content: locationMeta.og_meta_description ? locationMeta.og_meta_description : (this.templatedTagDescription || this.ogMetaDescription)
            },
            {
              vmid: 'og:image',
              property: 'og:image',
              content: locationMeta.og_meta_image ? locationMeta.og_meta_image : this.ogMetaImage
            }
        ]
        return {
          title: this.templatedTagTitle || locationMeta.meta_title || 'Korzyna',
          meta: currentLocationMeta,
          link: [
            {
              rel: 'preload',
              as: 'image',
              href: this.background
            },
            {rel: 'canonical', href: this.tagCanonicalPath}
          ]
        }
      } else {
        let locationMeta = {}
        if (this.getActivePartnersCategory && this.getActivePartnersCategory.hasOwnProperty('meta')) {
          this.getActivePartnersCategory.meta.map(meta => {
            if (meta.location_code === this.locationInfo.code) {
              locationMeta = meta
            }
          })
          let currentLocationMeta = [
              {
                vmid: 'description',
                name: 'description',
                content: this.templatedDescription || locationMeta.meta_description || this.metaDescription
              },
              {
                vmid: 'robots',
                name: 'robots',
                content: this.robotsContent
              },
              {
                vmid: 'keywords',
                name: 'keywords',
                content: locationMeta.meta_keywords ? locationMeta.meta_keywords : this.metaKeywords
              },
              {
                vmid: 'og:type',
                property: 'og:type',
                content: locationMeta.og_meta_type ? locationMeta.og_meta_type : this.ogMetaType
              },
              {
                vmid: 'og:title',
                property: 'og:title',
                content: locationMeta.og_meta_title ? locationMeta.og_meta_title : (this.templatedTitle || this.ogMetaTitle)
              },
              {
                vmid: 'og:description',
                property: 'og:description',
                content: locationMeta.og_meta_description ? locationMeta.og_meta_description : (this.templatedDescription || this.ogMetaDescription)
              },
              {
                vmid: 'og:image',
                property: 'og:image',
                content: locationMeta.og_meta_image ? locationMeta.og_meta_image : this.ogMetaImage
              }
          ]
          return {
            title: this.templatedTitle || locationMeta.meta_title || 'Korzyna',
            meta: currentLocationMeta,
            link: [
              {
                rel: 'preload',
                as: 'image',
                href: this.background
              },
              {rel: 'canonical', href: this.canonicalPath}
            ]
          }
        }
      }
    },
    methods:{
      s3Path,
      showAboutModal () {
        this.loadModal = true
        this.$bus.$emit('modal-show', 'modal-about')
      }
    }
  }
</script>

<style lang="scss" scoped>
h1 {
  font-size: 36px;
}

  .locationLink{
    text-decoration: underline;
    cursor: pointer;
    color: #ffffff;
    font-weight: bold;
  }
  .category-title {
    min-height: 43px;
    min-width: 505px;
    @media (max-width: 650px) {
      min-height: 30px;
      min-width: 340px;
    }
    @media (max-width: 400px) {
      min-width: 320px;
    }
  }
  .text-onclick-tag{
    @media (max-width: 650px) {
      min-height: 38px;
      min-width: 380px;
    }
    @media (max-width: 400px) {
      min-height: 57px;
      min-width: 320px;
    }
  }
  .head-image {
    position: relative;
    .head-image-bg{
      position: relative;
      padding-bottom: 15px;
      padding-top: 15px;

      img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        object-fit: cover;
        object-position: center;
      }
    }
    .image-wrapper{
      width: 95px !important;
      height: 95px !important;
      margin-bottom: 10px;
      border-radius: 50%;
      -webkit-box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px;
      background-color: white;
      padding: 10px;
      img{
        width: 100%;
        height: auto;
      }
    }

    .head-image-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      z-index: 3;

      a.store-title{
        color: #fff;
      }

    }
  }

  .container {
    background-size: cover;
    background-position: bottom center;
    background-repeat: no-repeat;
  }

  @media (max-width: 75em) {
    .store-title {
      font-size: 20px;
    }
  }
  @media (max-width: 64em) {

    .store-title {
      font-size: 16px;
    }

  }


  input
  {
    display: none;
  }

  #text
  {
    position: absolute;
    display: block;
    top: 0;
    padding-left: 10px;
    width: calc(100% - 10px);
    text-align: left;
  }

  .select
  {
    display: inline-block;
    width: 280px;
    height: 38px;
    line-height: 38px;
    position: relative;
    border-radius: 10px;

    .icon{
      width: 40px;
      height: 40px;
      background-color: #11bb2e;
      position: absolute;
      right: -2px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      img{
        padding-top: 8px;
      }
    }
  }

  .select input[name="list"]:not(:checked) ~ #text
  {
    color: black;
    background: white;
  }

  .select input[name="list"]:checked ~ #text
  {
    background: transparent;
    color: transparent;
    z-index: 2;
  }

  #select:disabled ~ .items #text
  {
    background: #eee;
  }

  .items
  {
    display: block;
    min-height: 38px;
    position: absolute;
    border: 1px solid #ddd;
    overflow: hidden;
    width: 240px;
    cursor: pointer;
    z-index: 2;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  #select:not(:checked) ~ .items
  {
    height: 30px;
  }

  .items label
  {
    border-top: 2px solid #ddd;
    display: none;
    padding-left: 10px;
    background: white;
    text-align: left    ;
  }

  .items label:hover
  {
    background: #eee;
    cursor: pointer;
  }

  #select:checked ~ .items
  {
    padding-top: 38px;
  }

  #select:checked ~ .items label
  {
    display: block;
  }

  .items input:checked + label
  {
    display: block!important;
    border: none;
    background: white;
  }

  /*#select:checked ~ .bg*/
  /*{*/
    /*position: fixed;*/
    /*top: 0;*/
    /*left: 0;*/
    /*bottom: 0;*/
    /*right: 0;*/
    /*z-index: 0;*/
    /*background: rgba(0,0,0,0.4);*/
  /*}*/
</style>
